export default "__VITE_ASSET__Ch04yLD2__"